import React from 'react';
import { Helmet } from 'react-helmet-async';
import MasterLayout from '../../masterLayout/MasterLayout';
import Breadcrumb from '../../components/Breadcrumb';
import SystemLogs from '../components/logs/SystemLogs';

const SystemLogsPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="System Logs" />
        <SystemLogs />
      </MasterLayout>
    </>
  );
};

export default SystemLogsPage;
